import {createBackendEditor, referenceActionData} from '../../form/ComponentEditor';
import {postData} from "../../../utils/request";
import React, {Fragment, useMemo, useRef, useState} from "react";
import {store} from "src/store";
import {showModal} from "../../../actions";
import Button from "../../form/Button";
import ComponentConfig from "../../form/ComponentConfig";
import get from "../../../utils/get";
import set from "../../../utils/set";
import {
    BarcodeFormatter,
    CurrencyFormatter, optionsTemplate, PercentFormatter,
    ProductSelect, UnitFormatter,
} from "../../../utils/formatters";
import ModalEditor from "../ModalEditor";
import ShippingEditor from "../shippingEditor";
import ContentLoader from "../../layout/ContentLoader";
import {
    calculateItemPrice,
    PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE,
    PriceView
} from "../../classes/Price";
import {ifCompletedInput, isTrue} from "../../../utils/other";
import BigNumber from "bignumber.js";
import {empty} from "locutus/php/var";
import AvailablePaymentProviders from "../payment/AvailablePaymentProviders";
import AvailableShippingProviders from "../shipping/AvailableShippingProviders";
import ContextBased from "../Context/ContextBased";
import TillCorrectionEditor from "../TillCorrectionEditor";
import {list} from "../../../utils/array";
import Modal from "../../layout/Modal";
import TillCorrectionList from "../lists/TillCorrectionList";
import Portal from "../../layout/Portal";
import {TillLastClosingDate} from "../TillClosingEditor";
import context from "../Context/context";
import DataGrid from "../../form/SelectorGrid/DataGrid";
import BoxEditor from "../BoxEditor";
import Agent from "./Elements/To/MemberCard";
import Select from "../../form/Select";
import CheckBox from "../../form/CheckBox";
import Icon from "../../form/Icon";
import Collapse from "../../layout/Collapse";
import classNames from "classnames";
import Customer from "./Elements/To/Customer";
import AddressControl from "../../form/AddressControl";
import PartnerEditor from "../partnerEditor";
import Invoice from "./Elements/Invoice";
import PaymentsControl from "../../form/purchase/payments";
import TextInput from "../../form/TextInput";
import {PropsRender} from "../../form/SelectorGrid/DataGrids/Types/PropsRender";
import {FieldDataProps} from "../../form/SelectorGrid/DataGrids/Types/FieldDataProps";
import {FieldProps} from "../../form/SelectorGrid/DataGrids/Types/FieldProps";
import ProductDisplayNameProps from "../../../utils/DataGrid/Fields/ProductDisplayNameProps";
import {Tooltip} from "react-tippy";
import Confirm, {smallDeleteProps} from "../../form/Confirm";
import debounce from "lodash-es/debounce";
import AbortablePromise from "../../../utils/promise/AbortablePromise";
import Header from "../../form/SelectorGrid/DataGrids/Table/Header";
import FieldData from "../../form/SelectorGrid/DataGrids/Table/FieldData";
import isEqual from "lodash-es/isEqual";

const TillCorrectionListButton = (props) => {
    const [opened, setOpened] = useState(false);
    return <Fragment>
        <div className="btn-group">
            <Button
                color="default"
                onClick={() => props.pristineForm()}
            >
                Korrekció
            </Button>
            <Button
                color="default"
                onClick={() => {
                    setOpened(true);
                }}
            >
                <span className="caret"/>
            </Button>
            <Portal>
                <Modal
                    size="large"
                    state={opened}
                    header="Korrekciók"
                    footer={props.footer}
                    buttons={[
                        {
                            text: "Bezárás",
                            props: {color: "default", disabled: props.disabled || props.isLoading},
                            onClose: true,
                            onClick: async () => {
                                setOpened(false);
                            }
                        }
                    ]}
                >
                    <TillCorrectionList
                        {...props}
                        filter={list(props.filter, {field: "transaction_date", value: props.lastClosingDate, operator: ">"})}
                    />
                </Modal>
            </Portal>
        </div>
    </Fragment>
}

const Correction = (props) => {
    return <TillLastClosingDate {...props}>
        <TillCorrectionEditor
            key="100"
            editorContext="ShopSalesTillCorrection"
            list={TillCorrectionListButton}
            editor={ModalEditor}
        />
    </TillLastClosingDate>
}

const setPrice = ({editItems, value, field, row, rowKey}) => {
    let oldItem = {...row};
    let newItem = {...row};
    set(newItem, field, value);
    if (!newItem.calculator && !oldItem.vat) {
        oldItem = {...newItem};
    }
    if (newItem.vat) {
        const saleprice = calculateItemPrice("saleprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        saleprice.setPrice(newItem.saleprice);
        const listprice = calculateItemPrice("listprice", field, newItem, oldItem, PAYMENT_PRICE_TYPE_UNIT_GROSS_PRICE);
        listprice.setPrice(newItem.listprice);

        if (field === "discount") {
            saleprice.setPrice(new BigNumber(listprice.getPrice()).minus(new BigNumber(listprice.getPrice()).dividedBy(100).multipliedBy(newItem.discount).toNumber()));
        } else {
            newItem.discount = new BigNumber(100).minus(new BigNumber(saleprice.getPrice()).dividedBy(listprice.getPrice()).multipliedBy(100)).toNumber().toFixed(2);
        }

        saleprice.boundTo(newItem, "saleprice");
        listprice.boundTo(newItem, "listprice");
        newItem.saleprice = saleprice.getPrice();
        newItem.listprice = listprice.getPrice();
    }
    if (editItems && JSON.stringify(oldItem) !== JSON.stringify(newItem)) {
        editItems({[rowKey]: newItem});
    }
    return newItem;
}

class PriceFieldComponent extends FieldData<any, any> {
    getFormatter(): PropsRender<FieldDataProps>[] {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [CurrencyFormatter(this.props.value)];
        }
        return formatters;
    }

    getEditor(): PropsRender<FieldDataProps>[] {
        if (!this.props.calculateGroupDiscount && this.props.row.component_type !== "Voucher") {
            return [
                <TextInput
                    type="decimal"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        if (ifCompletedInput(e)) {
                            setPrice({...this.props, value});
                        }
                    }}
                    onBlur={(e, field, value) => {
                        setPrice({...this.props, value});
                    }}
                />
            ];
        } else {
            return super.getEditor();
        }
    }

    layout(props, state): JSX.Element {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "currency");
        } else {
            props = {...props};
            props.className = classNames(props.className, "currency");
        }
        return super.layout(props, state);
    }
}

class DiscountFieldComponent extends FieldData<any, any> {
    getFormatter(): PropsRender<FieldDataProps>[] {
        const formatters = super.getFormatter();
        if (!formatters.length) {
           if (this.props.isAggregation) {
               return [
                   <div className="pull-right">
                       <Tooltip title="Kosár kedvezmény automatikus számolása">
                           <CheckBox
                               value={this.props.calculateGroupDiscount}
                               onIcon={{lib: "fas", name: "shopping-basket"}}
                               offIcon={{lib: "fas", name: "shopping-basket"}}
                               saveChanges={async (field, value) => {
                                   await this.props.setCalculateGroupDiscount(value);
                               }}
                           />
                       </Tooltip>
                   </div>
               ]
           } else {
               return [PercentFormatter(this.props.value)];
           }
        }
        return formatters;
    }

    getEditor(): PropsRender<FieldDataProps>[] {
        if (!this.props.calculateGroupDiscount && this.props.row.component_type !== "Voucher") {
            return [
                <TextInput
                    type="decimal"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        if (ifCompletedInput(e)) {
                            setPrice({...this.props, value});
                        }
                    }}
                    onBlur={(e, field, value) => {
                        setPrice({...this.props, value});
                    }}
                />
            ];
        } else {
            return super.getEditor();
        }
    }

    layout(props, state): JSX.Element {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "discount");
        } else {
            props = {...props};
            props.className = classNames(props.className, "discount");
        }
        return super.layout(props, state);
    }
}

class QtyField extends FieldData<any, any> {
    getFormatter(): PropsRender<FieldDataProps>[] {
        const formatters = super.getFormatter();
        if (!formatters.length) {
            return [UnitFormatter(this.props.value)];
        }
        return formatters;
    }

    getEditor(): PropsRender<FieldDataProps>[] {
        if (this.props.row.component_type !== "Voucher") {
            return [
                <TextInput
                    type="number"
                    name={this.props.field}
                    label={false}
                    focus
                    value={this.props.value}
                    onKeyDown={(e, field, value) => {
                        if (ifCompletedInput(e)) {
                            if (parseInt(value || "0") === 0) {
                                this.removeItems({[this.props.rowKey]: this.props.row});
                            } else {
                                setPrice({...this.props, value});
                            }
                        }
                    }}
                    onBlur={(e, field, value) => {
                        if (parseInt(value || "0") === 0) {
                            this.removeItems({[this.props.rowKey]: this.props.row});
                        } else {
                            setPrice({...this.props, value});
                        }
                    }}
                />
            ];
        } else {
            return super.getEditor();
        }
    }

    layout(props, state): JSX.Element {
        if (props.className instanceof Function) {
            props = {...props};
            props.className = classNames(props.className(props), "unit");
        } else {
            props = {...props};
            props.className = classNames(props.className, "unit");
        }
        return super.layout(props, state);
    }
}

const defaultItemsView = ["id", "product_id", "OperationList_id", "vat", "component_type", "component_id", ...PriceView("saleprice"), "saleprice", ...PriceView("listprice"), "listprice", "instock", "sold", "used", "qty"];

const fields: {
    [field: string]: {
        type?: PropsRender<FieldDataProps>,
        props: FieldProps
    }
} = {
    "displayname": {
        props: {
            ...ProductDisplayNameProps("component_id"),
            sortable: false,
            filterable: false,
            width: 5,
        }
    },
    "barcode": {
        props: {
            header: 'Vonalkód',
            width: 1,
        }
    },
    "listprice_gross": {
        type: PriceFieldComponent,
        props: {
            header: "Lista ár",
            width: 1,
        }
    },
    "discount": {
        type: DiscountFieldComponent,
        props: {
            header: "Kedvezmény",
            width: 1,
            aggregation: {
                type: ""
            },
        }
    },
    "saleprice_gross": {
        type: PriceFieldComponent,
        props: {
            header: "Eladási ár",
            width: 1,
        }
    },
    "qty": {
        type: QtyField,
        props: {
            header: "Darabszám",
            width: 1,
            tooltip: ({row, isAggregation}) => {
                return !isAggregation && parseInt(row.instock) < parseInt(row.qty) ? "Készlethiány!" : "";
            },
            aggregation: {
                type: "SUM",
            },
        }
    },
    // nettó összesen
    // bruttó összesen
    "saleprice_net_total": {
        props: {
            header: "Nettó összesen",
            width: 1,
            formatter: ({value}) => CurrencyFormatter(value),
            aggregation: {
                type: "SUM",
            },
            className: "currency",
        }
    },
    "saleprice_gross_total": {
        props: {
            header: "Bruttó összesen",
            width: 1,
            formatter: ({value, isAggregation, row, ...rest}) => {
                if (isAggregation) {
                    return <span className="total">{CurrencyFormatter(value, row)}</span>
                }
                return CurrencyFormatter(value, row);
            },
            aggregation: {
                type: "SUM",
            },
            className: "currency",
        }
    },
    "actions": {
        props: {
            header: ' ',
            width: "auto",
            formatter: ({row, removeItems}) => {
                return <Confirm
                    {...smallDeleteProps}
                    onAccept={() => {
                        removeItems([row]);
                    }}
                />
            }
        }
    }
}

const GroupTemplate = ({groupFieldValue, visibleFields}) => {
    if (groupFieldValue) {
        return <tr className="p-rowgroup-header">
            <td colSpan={visibleFields.length}>
                <div className="p-rowgroup-header-name">
                    <span>{groupFieldValue} akció</span>
                </div>
            </td>
        </tr>;
    }
    return <tr className="p-rowgroup-header">
        <td colSpan={visibleFields.length}>
            <div className="p-rowgroup-header-name">
                <span>Egyéb termékek</span>
            </div>
        </td>
    </tr>;
}

const AddTemplate = (props) => {
    const [usedVoucher, setUsedVoucher] = useState(false);
    const {visibleFields, operationlist, view, addItems} = props;
    return <Fragment>
        <Header {...props} />
        <thead className="p-datatable-thead">
        <tr>
            <th className="p-resizable-column" colSpan={visibleFields.length}>
                <div className="add-item">
                    <Select
                        searchFormatter={BarcodeFormatter}
                        placeholder="Vonalkód vagy cím"
                        labelKey="displayname"
                        optionsTemplate={ProductSelect}
                        label={false}
                        autoSelect={true}
                        openIfHasOptions={true}
                        parameters={{
                            partner: operationlist?.seller?.partner_id,
                            OperationList_id: operationlist?.id,
                            seller: operationlist?.seller?.partner_id,
                            customer: operationlist?.customer?.partner_id || operationlist?.seller?.partner_id,
                            store: operationlist?.pos?.location?.id
                        }}
                        component="OperationPoolItem"
                        filter={[
                            {
                                field: "component_type",
                                value: ["Event", "Royalty"],
                                operator: "not in"
                            }
                        ]}
                        view={view}
                        storeType="remote"
                        valueKey="component_id"
                        saveChanges={async (field, item) => {
                            item.qty = parseInt(item.qty || "0") + 1;
                            if (item.component_type === "Voucher") {
                                if (item.sold) {
                                    if (item.used) {
                                        setUsedVoucher(true);
                                    } else {
                                        const payments = list(operationlist.payments);
                                        let voucherIndex = payments.findIndex((v) => v.serviceprovider_type === "VoucherPayment");
                                        const voucher = voucherIndex !== -1 ? payments[voucherIndex] : null;
                                        let oldValue = voucher?.vouchers || [];
                                        let vouchers = JSON.parse(JSON.stringify(oldValue));
                                        const index = vouchers.findIndex((i) => i.id + "" === "" + item.component_id);
                                        if (index === -1) {
                                            vouchers.push({...item, id: item.component_id});
                                        }
                                        if (!isEqual(oldValue, vouchers)) {
                                            if (voucherIndex === -1) {
                                                voucherIndex = payments.length;
                                                payments[voucherIndex] = {serviceprovider_type: "VoucherPayment"};
                                            }
                                            set(payments, voucherIndex + ".vouchers", vouchers);
                                            let voucherAmount = vouchers.reduce((sum, voucher) => sum.plus(voucher.amount || voucher.saleprice || 0), new BigNumber(0)).toNumber();
                                            set(payments, voucherIndex + ".amount", voucherAmount);
                                            await props.setFieldValue("payments", payments);
                                        }
                                    }
                                    return;
                                }
                                if (item.qty > 1) return;
                            }
                            addItems([item]);
                        }}
                    />
                </div>
                {usedVoucher && <Portal>
                    <Modal
                        header="Beváltott utalvány!"
                        state="on"
                        size="small"
                        disabled={props.disabled || props.isLoading}
                        buttons={[
                            {
                                text: "Rendben",
                                props: {color: "danger", disabled: props.disabled || props.isLoading},
                                onClick: async () => {
                                    setUsedVoucher(false);
                                }
                            }
                        ]}
                    >
                        Ez az utalvány már be lett váltva!
                    </Modal>
                </Portal>}
            </th>
        </tr>
        </thead>
    </Fragment>
}

class LoyaltyPointOperationListWallet extends React.Component<any, any> {

    protected exchangeableRequest: AbortablePromise<any>;

    componentWillUnmount() {
        this.setExchangeablePoints("_", 0);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        const oldAgentId = parseInt(prevProps.values?.agent?.id || "0");
        const newAgentId = parseInt(this.props.values?.agent?.id || "0");
        if (oldAgentId !== newAgentId) {
            this.setExchangeablePoints("_", 0);
        }
    }

    setExchangeablePoints = debounce( async (field, value) => {
        if (parseInt(this.props.values.xtradata?.loyaltypoints || "0") !== parseInt(value || "0")) {
            this.exchangeableRequest && this.exchangeableRequest.abort();
            this.exchangeableRequest = postData({
                action: "LoyaltyPointOperationListWallet.setOperationListPoints",
                operationlist: this.props.values[this.props.componentConfig.idfield],
                loyaltypoints: value
            });
            this.exchangeableRequest.then(async () => {
                this.props.onAmountSave();
            });
        }
    }, 300);

    render() {
        if (!this.props.values?.agent?.id) return null;
        return (
            <div className={classNames("form-row loyalty-wallet", {loading: this.props.isLoading})} id="loyalty-wallet">
                <div className="col-md-12 heading">Törzsvásárlói pontbeváltás</div>
                <div className="form-group col-md-4">
                    <TextInput
                        label="Összes pont"
                        className="form-control"
                        type="number"
                        id="all_points"
                        name="all_points"
                        value={this.props.values.loyaltypoints_amount}
                        disabled={true}
                    />
                </div>
                <div className="form-group col-md-4">
                    <TextInput
                        label="Beváltható pontok"
                        className="form-control"
                        type="number"
                        id="exchangeable"
                        name="exchangeable"
                        value={this.props.values.loyaltypoints_exchangeable_points}
                        disabled={true}
                    />
                </div>
                <div className="form-group col-md-4">
                    <label className="control-label">Beváltandó pontok</label>
                    <div className="input-group">
                        <TextInput
                            label={false}
                            className="form-control"
                            type="number"
                            id="to_be_exchanged"
                            name="to_be_exchanged"
                            max={this.props.values.loyaltypoints_exchangeable_points}
                            value={this.props.values.xtradata?.loyaltypoints || 0}
                            saveChanges={this.setExchangeablePoints}
                            disabled={this.props.isLoading}
                        />
                        <div className="input-group-btn">
                            {this.props.values.xtradata?.loyaltypoints > 0 ? <Button
                                disabled={this.props.isLoading}
                                color="default"
                                onClick={() => {
                                    this.setExchangeablePoints("to_be_exchanged", 0);
                                }}
                                tooltip="Törlés"
                                icon={{lib: "fas", name: "times"}}
                            /> : null}
                            <Button
                                disabled={this.props.isLoading}
                                color="default"
                                onClick={() => {
                                    const n = Math.min(this.props.values.loyaltypoints_amount, this.props.values.loyaltypoints_exchangeable_points);
                                    if (n != (this.props.values.xtradata?.loyaltypoints || 0)) {
                                        this.setExchangeablePoints("to_be_exchanged", n);
                                    }
                                }}
                                tooltip="Összes pont beváltása"
                                icon={{lib: "fas", name: "wallet"}}
                            />
                        </div>
                    </div>
                </div>
                <div className="clearfix" />
            </div>
        )
    }
}

const Form = React.forwardRef((props, ref) => {
    const itemsRef = useRef(null);
    const loyaltyRef = useRef(null);
    const swapPortalId = useMemo(() => "swap_portal_" + (new Date()).getTime(), []);
    const calculateGroupDiscount = isTrue(get(props.values, "xtradata.calculateGroupDiscount"));
    const itemsView = useMemo(() => {
        if (calculateGroupDiscount) {
            return [...defaultItemsView, "groupdiscount.name"];
        } else {
            return defaultItemsView;
        }
    }, [calculateGroupDiscount]);
    const itemsGroupField = useMemo(() => {
        return calculateGroupDiscount ? "groupdiscount.name" : null;
    }, [calculateGroupDiscount]);
    const itemsOrder = useMemo(() => {
        return calculateGroupDiscount ? {field: "groupdiscount", direction: "DESC"} : [{field: "updated_at", direction: "DESC"},{field: "created_at", direction: "DESC"}];
    }, [calculateGroupDiscount]);
    const notaccepted = !props.values.creatable;
    return <Fragment>
        <BoxEditor
            theme="default"
            footer={<div className="d-flex justify-content-between">
                <Button
                    disabled={props.isLoading || !props.values[props.componentConfig.idfield] || notaccepted}
                    color={props.isLoading ? "default" : (notaccepted ? "danger" : "primary")}
                    className="pull-left"
                    icon={props.isLoading ? {lib: "fas", name: "sync-alt", spin: true} : {lib: "fa", name: "money"}}
                    onClick={async (e) => {
                        const values = await referenceActionData(props.values, props.componentConfig);
                        values.autocheckup = true;
                        values.getInvoice = true;
                        const data = JSON.parse(JSON.stringify(await referenceActionData(values, props.componentConfig)));
                        data.payments = (data.payments || []).map((payment) => {
                            if (!empty(payment.vouchers)) {
                                payment.vouchers = payment.vouchers.map((voucher) => voucher.id);
                            }
                            return payment;
                        });
                        await props.processAction(async () => {
                            const response = await postData({
                                action: 'OperationList.doAction',
                                actionname: 'create',
                                data,
                            });
                            if (response.success) {
                                await props.pristineForm(false);
                                if (response.invoice) {
                                    window.open(response.invoice, '_blank');
                                }
                            } else if (!response.success) {
                                if (response.msg) {
                                    store.dispatch(showModal({
                                        theme: "danger",
                                        header: "",
                                        text: response.msg
                                    }));
                                }
                            }
                            return false;
                        });
                    }}
                >
                    Eladás
                </Button>
                <Correction />
                <Button
                    color="default"
                    onClick={() => props.pristineForm()}
                >
                    Új
                </Button>
            </div>}
        >
            <div className="shop-sales">
                <div className="row form-row">
                    <div className="col-md-8">
                        <Agent {...props} />
                    </div>
                    <div className="col-md-4">
                        <Select
                            label="Kupon(ok)"
                            component="discount"
                            optionsTemplate={optionsTemplate("coupon")}
                            storeType="remote"
                            name="coupons"
                            labelKey="promo_code"
                            valueKey="id"
                            autoSelect={true}
                            value={props.values.coupons}
                            isMulti={true}
                            openIfHasOptions={true}
                            filter={[
                                {field: "promotion.pos", systemvalue: "Context.pos"},
                                {field: "promotion.active", value: 1}
                            ]}
                            saveChanges={async (field, value) => {
                                await props.setFieldValue(field, value);
                                itemsRef?.current?.refreshBackground();
                                loyaltyRef?.current?.refreshBackground();
                            }}
                        />
                    </div>
                </div>
                <DataGrid
                    ref={itemsRef}
                    pageSize={0}
                    data={props.values}
                    header={AddTemplate}
                    setFieldValue={props.setFieldValue}
                    operationlist={props.values}
                    onItemsChanged={async () => {
                        await props.reloadForm();
                        return true;
                    }}
                    componentConfig={props.componentConfig}
                    calculateGroupDiscount={props.values?.xtradata?.calculateGroupDiscount}
                    setCalculateGroupDiscount={async (value) => {
                        await props.setFieldValue("xtradata.calculateGroupDiscount", value);
                    }}
                    name="items"
                    view={itemsView}
                    order={itemsOrder}
                    className="p-small-table"
                    groupFieldTemplate={GroupTemplate}
                    groupField={itemsGroupField}
                    fields={fields}
                    rowClassName={({item}) => {
                        return {"warning color": !parseInt(item.instock) && item.component_type !== "Voucher"};
                    }}
                />
                <div id={swapPortalId} />
                <div className="row form-row">
                    <div className="col-md-12">
                        <CheckBox
                            name="xtradata.createinvoice"
                            value={props.values?.xtradata?.createinvoice}
                            label={<span><Icon lib="fa" name="file"/> Számlázás</span>}
                            saveChanges={props.setFieldValue}
                        />
                        <Collapse collapsed={isTrue(props.values?.xtradata?.createinvoice)}>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="row">
                                        {props.values.customer ? <div className="col-md-10">
                                            <div className="row">
                                                <div className={classNames({
                                                    "col-md-3": props.values.customer,
                                                    "col-md-12": !props.values.customer
                                                })}>
                                                    <Customer
                                                        {...props}
                                                        props={{}}
                                                        label="Partner"
                                                    />
                                                </div>
                                                {props.values.customer &&
                                                <div className="col-md-9">
                                                    <div className="row">
                                                        <AddressControl
                                                            disabled={"disabled"}
                                                            value={props.values.customer.address}
                                                            label="Cím"
                                                        />
                                                    </div>
                                                </div>
                                                }
                                            </div>
                                        </div> : null}
                                        <PartnerEditor
                                            editorContext="ShopSalesPartnerEditor"
                                            editor={ModalEditor}
                                            other={() => null}
                                            selection={null}
                                            list={(listProps) => {
                                                return <Fragment>
                                                    {!props.values.customer ? <div className="col-md-12">
                                                        <label className="control-label">&nbsp;</label>
                                                        <div className="d-flex flex-column">
                                                            {listProps.footer}
                                                        </div>
                                                    </div> : <div className="col-md-1">
                                                        <label className="control-label">&nbsp;</label>
                                                        <Button
                                                            icon={{lib: "fas", name: "pencil-alt"}}
                                                            tooltip="Partner adatok szerkesztése"
                                                            block={true}
                                                            color="default"
                                                            onClick={() => {
                                                                listProps.loadForm({partner_id: props.values.customer.partner_id});
                                                            }}
                                                        />
                                                    </div>}
                                                </Fragment>;
                                            }}
                                            onPartnerSelected={async (data, componentConfig, editorProps) => {
                                                props.setFieldValue("customer", data);
                                                await editorProps.setFormValues({});
                                            }}
                                            saveForm={async (data, componentConfig, editorProps) => {
                                                props.setFieldValue("customer", data);
                                                await editorProps.setFormValues({});
                                            }}
                                        />
                                        {props.values.customer && <Fragment>
                                            <div className="col-md-1">
                                                <label className="control-label">&nbsp;</label>
                                                <Button
                                                    icon={{lib: "fa", name: "times"}}
                                                    tooltip="Mégse"
                                                    block={true}
                                                    color="danger"
                                                    onClick={() => {
                                                        props.setFieldValue("customer", null);
                                                    }}
                                                />
                                            </div>
                                        </Fragment>}
                                    </div>
                                </div>
                            </div>
                            <Invoice
                                props={{
                                    values: props.values,
                                    getProps: props.getFieldProps,
                                    getValue: (field) => get(props.values, field),
                                    setFieldValue: props.setFieldValue,
                                }}
                            />
                        </Collapse>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-12">
                        <LoyaltyPointOperationListWallet
                            ref={loyaltyRef}
                            {...props}
                            onAmountSave={async () => {
                                await props.reloadForm();
                                itemsRef?.current?.refreshBackground();
                            }}
                        />
                    </div>
                    <div className="col-md-3">
                        <div className="row form-row">
                            <PaymentsControl
                                availableProviders={props.availablePaymentProviders}
                                {...props.getFieldProps("payments")}
                                disabled={props.disabled || props.isLoading}
                                name="payments"
                                value={props.values.payments}
                                label="Fizetési mód"
                                swapPortalId={swapPortalId}
                                rounding={props.values.rounding || 0}
                                overpay={props.values.overpay || 0}
                                cost={props.values.cost || 0}
                                total={props.values.total || 0}
                                saveChanges={(field, value) => {
                                    props.setFieldValue(field, value);
                                }}
                                providerTheme="radio"
                            />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <DataGrid
                            className="vat-aggregation turnover_register"
                            pageSize={0}
                            emptyMessage={false}
                            value={props.values.turnover_register}
                            fields={{
                                "vat.name": {
                                    props: {
                                        className: "name",
                                        header: "Gyüjtő"
                                    }
                                },
                                "cost": {
                                    props: {
                                        header: "Összeg",
                                        className: "cost",
                                        formatter: ({value}) => {
                                            return CurrencyFormatter(value);
                                        }
                                    }
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </BoxEditor>
    </Fragment>;
});

class ShopSalesEditor extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.state = {
            loading: !this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield]
        }
        if (!this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield]) {
            this.loadNew();
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!this.props.values[this.props.componentConfig.idfield] && !this.props[this.props.componentConfig.idfield] && !this.state.loading) {
            this.setState({loading: true}, this.loadNew);
        }
    }

    loadNew = async () => {
        await this.props.pristineForm();
        this.setState({loading: false});
    }

    render() {
        if (!this.props.values[this.props.componentConfig.idfield]) {
            return <ContentLoader/>;
        }
        return <Fragment>
            <Form {...this.props} />
        </Fragment>
    }
}

const Editor = (props) => {
    return <AvailableShippingProviders {...props}>
        <AvailablePaymentProviders {...props}>
            <ShopSalesEditor {...props} />
        </AvailablePaymentProviders>
    </AvailableShippingProviders>;
}

export default context(createBackendEditor({
    componentName: "OperationList",
    WrappedComponent: (props) => {
        return (
            <Fragment>
                <ContextBased needle={["till"]}>
                    <ComponentConfig componentName="OperationItem" componentConfigAs="OperationItemConfig" {...props}>
                        <Editor />
                    </ComponentConfig>
                </ContextBased>
                {!!props.till?.pos?.location?.id && !props.closing && <Fragment>
                    <ShippingEditor
                        collapsed={true}
                        editor={ModalEditor}
                        listFilter={[
                            {
                                field: "state",
                                value: 2
                            }
                        ]}
                        selection={null}
                        pos={props.till.pos}
                    />
                    {/*<EventReservationEditor
                        collapsed={true}
                        editor={ModalEditor}
                        selection={null}
                        pos={(props.till || {}).pos}
                    />*/}
                </Fragment>}
            </Fragment>
        );
    },
    editor: "ShopSales",
    dirtyFlag: (values) => {
        return !parseInt(values.saved) && values.id;
    },
    props: {
        saveable: false,
        componentActions: async (action, data, params, componentConfig) => {
            data = JSON.parse(JSON.stringify(await referenceActionData(data, componentConfig)));
            data.payments = (data.payments || []).map((payment) => {
                if (!empty(payment.vouchers)) {
                    payment.vouchers = payment.vouchers.map((voucher) => voucher.id);
                }
                return payment;
            });
            if (data.membercard) {
                data.membercard = data.membercard.barcode;
            }
            params.preset = "ShopSales";
            data = {...data};
            delete data.total;
            delete data.turnover_register;
            delete data.vouchers;
            delete data.items;
            delete data.created_by;
            delete data.modified_at;
            return {action,data,params};
        }
    }
}), {needle: ["till"]});